import ApiService from './ApiService';

export default class DashboardApi extends ApiService {
    constructor() {
        super('system');
    }

    getDashboards() {
        return this.get('dashboards');
    }

    // #region Vehicles to arrange in 24h
    getVehiclesToArrangeIn24h(payload) {
        return this.get('dashboards/vehicle-arrange-within-24h', payload);
    }

    getStatistics() {
        return this.get('dashboards/statistics');
    }
    // #endregion Vehicles to arrange in 24h

    // #region Vehicles overdue for arrangement
    getVehiclesOverdueForArrangement(payload) {
        return this.get('dashboards/expired-vehicle-arrangement', payload);
    }
    // #endregion Vehicles overdue for arrangement

    getLateReturnedBikes(payload) {
        return this.get('late-returned-bikes', payload);
    }

    getUnpaidReservations(payload) {
        return this.get('dashboards/waiting-payment', payload);
    }

    getLatePaymentOrders(payload) {
        return this.get('late-payment-orders', payload);
    }

    getAddLatePayments(payload) {
        return this.get('dashboards/extra-charge', payload);
    }
}
